import { gql } from "@apollo/client";

export const AddTransformTicket = gql`
  mutation AddTransformTicket(
    $token: String!
    $customerID: ID!
    $input: TransformTicketDetails!
  ) {
    AddTransformTicket(token: $token, customerID: $customerID, input: $input) {
      id
      ticketNo
      ticketDate
      reason
      type
      priority
      openRemarks
      lastRemarks
      poleNum
      status
      tableLevel
      resolvedDate
      junctionID
      companyID
      ticketDetails{
        id
      }
    }
  }
`;

export const AddTransformTicketDetails = gql`
  mutation AddTransformTicketDetails(
    $token: String!
    $todaysDate: Time!
    $customerID: ID!
    $ticketID: ID!
    $input: TransformTicketDetailsInput!
  ) {
    AddTransformTicketDetails(
      token: $token
      todaysDate: $todaysDate
      customerID: $customerID
      ticketID: $ticketID
      input: $input
    ) {
      id
      companyID
    }
  }
`;
